export const getBase64Image = async (url) => {
    // Return null early if url is undefined, null, empty, or literally the string 'undefined'
    if (!url || typeof url !== 'string' || url.trim() === '' || url === 'undefined') {
      return null;
    }

    // Check if it's a blob URL that might be expired.
    // Blob URLs do not support HEAD requests (ERR_METHOD_NOT_SUPPORTED in
    // all Chromium-based browsers). Use GET instead — the browser serves
    // the blob from memory so the cost is negligible.
    if (url.startsWith('blob:')) {
      try {
        const checkResponse = await fetch(url, { method: 'GET' });
        if (!checkResponse.ok) {
          return null;
        }
      } catch {
        // Blob URL is expired or invalid
        return null;
      }
    }

    try {
      const response = await fetch(url, {
        mode: 'cors',
        cache: 'no-cache'
      });

      if (!response.ok) throw new Error("Failed to fetch image");

      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      // Only log error if it's not a network/CORS issue (to reduce console noise)
      if (!error.message?.includes('Failed to fetch') && !error.message?.includes('NetworkError')) {
        console.error("Error fetching image:", error);
      }
      return null;
    }
};